import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";

import { MatSnackBar } from '@angular/material';

import {Observable} from 'rxjs/Observable';
import { Subject }  from 'rxjs/Subject';
// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import { distinctUntilChanged, map, startWith } from 'rxjs/operators';

import { DateAdapter, NativeDateAdapter } from '@angular/material';

import { FireDataService } from '../fire-data.service';

import { CaseType } from '../case-type';
import { CASES } from '../case-list';

@Component({
  selector: 'app-case-teacher',
  templateUrl: './case-teacher.component.html',
  styleUrls: ['./case-teacher.component.css']
})
export class CaseTeacherComponent implements OnInit, OnChanges {

  @Input() modelData;
  @Output()
  childClick: EventEmitter<String> = new EventEmitter<String>();

  teacherForm: FormGroup;
  caseSchedule: object
  row: object
  cases: CaseType[];
  selectedCase: CaseType;
  teacherTypes = [ {code: 'C', name: 'Curriculare'}, {code: 'S', name: 'Sostegno'} ];
  type = 'C';

  teachers: Observable<any>;
  private termTeacher = new Subject<string>();

  // initialize a private variable _data, it's a BehaviorSubject
  
  constructor(private fds: FireDataService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private location: Location, 
    dateAdapter: DateAdapter<NativeDateAdapter>, public snackBar: MatSnackBar) {
    
      dateAdapter.setLocale('it-IT');  // for MDdatePicker
      this.row = {type: 'C', teacher : '', startDate: new Date(new Date().getFullYear(),new Date().getMonth() , new Date().getDate()).valueOf(), 
      endDate: new Date(new Date().getFullYear(),new Date().getMonth() , new Date().getDate()).valueOf(), settled: false, note: ''};

      this.caseSchedule = {"show":false,"items": null, "message": ""}
    

   }

  ngOnInit() {
    /*
    this.cases = CASES;
    var parId = 16
    function findId(el) {
      return parId == el.id;
    } */
    this.selectedCase = this.modelData['caseProperty']
    this.initializeModel(this.row)
    this.createForm(this.modelData);
    this.sendDataToParent(this.modelData)

    this.teachers = this.termTeacher
    .debounceTime(300)        // wait 300ms after each keystroke before considering the term
    .distinctUntilChanged()   // ignore if next search term is same as previous
    .switchMap(term => term   // switch to new observable each time the term changes
      // return the search observable
      ? this.fds.searchTeacher(this.type,term)
      // or the observable of empty array if there was no search term
      : Observable.of<any>([]))
    .catch(error => {
      // TODO: add real error handling
      console.log(error);
      return Observable.of<any[]>([]);
    });
    this.validateTeacherForm();
  }

  ngOnChanges(changes) {
    console.log("TEACHERS Model data changes...:", changes)
    if (changes['modelData']) {
      
      if (this.modelData['inizializeModel']) {
        this.initializeModel(this.row)
        this.createForm(this.modelData);
        this.modelData['inizializeModel'] = false
        this.validateTeacherForm();
        this.sendDataToParent(this.modelData)
      }
      if (this.modelData['groupModel']['teachers'] == []) {this.inizializeModelPartial()}
    }
  }

  private initializeModel(row) {
    for (var prop in row) {
      if(!this.modelData[prop]) {this.modelData[prop] = row[prop]}
    }
    this.inizializeModelPartial()
    if (this.modelData['isEditingMode']) {
      this.loadTeacherGroups ('0', this.modelData['type'], this.modelData['teacher'], this.modelData['startDate'], this.modelData['endDate'])
      } else {
      this.caseSchedule['show'] = false
    }  
  }

  private inizializeModelPartial() {
    //console.log("Partial inizialize....")
    if(this.modelData['groupModel']['startDate']) {this.modelData['startDate'] = this.modelData['groupModel']['startDate']}
    if(this.modelData['groupModel']['endDate']) {this.modelData['endDate'] = this.modelData['groupModel']['endDate']}
    if(this.modelData['groupModel']['settled']) {this.modelData['settled'] = this.modelData['groupModel']['settled']}
    if(this.modelData['groupModel']['schedule']) {this.caseSchedule['items'] = this.modelData['groupModel']['schedule']}
  }

  createForm(row) {
    this.teacherForm = this.fb.group({
      type: row.type,
      teacher: row.teacher,
      //teacher: [row.firstTeacher, Validators.required, {updateOn: 'blur', asyncValidators: [this.validateTeacher]} ],
      startDate: new Date(row.startDate),
      endDate: new Date(row.endDate),
      //settled: {value: row.settled, disabled: this.selectedCase['settled']['disable']},   // don't work
      settled: row.settled,
      note: row.note,
     });
     //if (this.selectedCase['settled']['disable']) {this.teacherForm.controls['settled'].disable()}   // don't work
  }

  private validateTeacherForm() {
    this.teacherForm.get('startDate').valueChanges
    .subscribe(val => {
      this.modelDataUpdate ('startDate', val)
      if (this.modelData['groupModel']['startDate'] > val || val > this.modelData['groupModel']['endDate']) {
        this.teacherForm.get('startDate').setValue(new Date(this.modelData['groupModel']['startDate']))
        this.teacherForm.get('startDate').updateValueAndValidity();
        this.snackBar
        .open('Le data di inizio e fine devono essere nel range di quelle della classe', '(chiudi)', {
          duration: 5000
        });
      }
      if (this.teacherForm.get('teacher').value) {
        this.loadTeacherGroups ('1', this.teacherForm.get('type').value, this.teacherForm.get('teacher').value, 
                                this.teacherForm.get('startDate').value, this.teacherForm.get('endDate').value) 
      }
      if (val > this.teacherForm.get('endDate').value) {
        this.teacherForm.get('endDate').setValue(val);
        this.teacherForm.get('endDate').updateValueAndValidity();

      }
    });

    this.teacherForm.get('endDate').valueChanges
    .subscribe(val => {
      this.modelDataUpdate ('endDate', val)
      if (this.modelData['groupModel']['startDate'] > val || val > this.modelData['groupModel']['endDate']) {
        this.teacherForm.get('endDate').setValue(new Date(this.modelData['groupModel']['endDate']))
        this.teacherForm.get('endDate').updateValueAndValidity();
        this.snackBar
        .open('Le data di inizio e fine devono essere nel range di quelle della classe', '(chiudi)', {
          duration: 5000
        });
      }
      if (this.teacherForm.get('teacher').value) {
        this.loadTeacherGroups ('2', this.teacherForm.get('type').value, this.teacherForm.get('teacher').value, 
                                this.teacherForm.get('startDate').value, this.teacherForm.get('endDate').value) 
      }
      if (val < this.teacherForm.get('startDate').value) {
        this.teacherForm.get('startDate').setValue(val);
        this.teacherForm.get('startDate').updateValueAndValidity();
      }
    });

    this.teacherForm.get('type').valueChanges
    .subscribe(val => {
      this.modelDataUpdate ('type', val)
        this.teacherForm.get('teacher').setValue('');
        this.teacherForm.get('teacher').updateValueAndValidity();
        this.caseSchedule['show'] = false
        this.modelDataUpdate ('schedule', '')
        /*
        if (this.teacherForm.get('teacher').value) {
          this.loadTeacherGroups (this.teacherForm.get('type').value, this.teacherForm.get('teacher').value, this.teacherForm.get('startDate').value) 
        } */
    });

    this.teacherForm.get('settled').valueChanges
    .subscribe(val => {
      this.modelDataUpdate ('settled', val)
      if (!val && this.teacherForm.get('teacher').value) {
        this.modelDataUpdate ('schedule', this.caseSchedule['items'])
      } else {this.modelDataUpdate ('schedule', '')}
      this.caseSchedule['show'] = val ? false : this.teacherForm.get('teacher').value ? true : false
    });

    this.teacherForm.get('note').valueChanges
    .debounceTime(500)  
    .subscribe(val => {
      this.modelDataUpdate ('note', val)
    });

    this.teacherForm.get('teacher').valueChanges
    .subscribe(val => {
      if (val) {
        this.modelDataUpdate ('teacher', val)
        this.loadTeacherGroups ('3', this.teacherForm.get('type').value, val, this.teacherForm.get('startDate').value, this.teacherForm.get('endDate').value) 
      }
    });

  }

  private loadTeacherGroups (fake,type, teacher, reqDate, endDate) {
    //console.log("Fake log ...: ", fake)
    this.fds.getTeacherSchedule(type, teacher, reqDate, endDate, this.selectedCase.type)
      .then(res => {
        this.caseSchedule['message'] = ''
        if (res == 'no class') {
          this.caseSchedule['message'] = ' ... no groups this day ...'
          this.caseSchedule['show'] = true
        } else {
          this.scheduleMerge(res)
          if (!this.modelData['settled']) {
            this.caseSchedule['show'] = true
            this.modelDataUpdate ('schedule', this.caseSchedule['items'])
            //console.log("After schedule merge...:", this.caseSchedule)
          } else {
            this.caseSchedule['show'] = false
            this.modelDataUpdate ('schedule', '')}
          }
      })
  }

  private scheduleMerge (sched) {
    //console.log("Teacher schedule merge, ENTRY ..:", sched)
    var schedule = [], daySched, daySchedule, arr, itemToFind
    if (this.modelData['isEditingMode']) {
      daySched = []
      //console.log("Teacher schedule merge, CLASSES ..:", this.modelData['classes'])
      for (var s in this.modelData['classes']) {
        daySched.push({'sched': s,'group': this.modelData['classes'][s], 'value': true})
      }
      schedule.push({"day": this.fds.getDayKey(this.modelData['startDate']), "value": daySched})
      this.modelData['classes'] = []
      //console.log("Teacher schedule merge, SCHEDULE ..:", schedule)
    } else {
      schedule = this.modelData['groupModel']['schedule'] ? this.modelData['groupModel']['schedule'] : []
    }
    // if no previous schedule is found, sched is the schedule to return, no merge is needed
    if (schedule.length == 0) {
      this.caseSchedule['items'] = sched
      //console.log("Teacher schedule merge, NO SCHEDULE ..:", this.caseSchedule['items'])
      return
    }
    // if there is a group schedule this is ok, it manages the right daySched
    if (this.modelData['groupModel']['schedule']) {
      arr = this.fds.copyArray(schedule)
      for (var d in sched) {
        itemToFind = sched[d]['day']
        daySchedule = arr[arr.findIndex(dayIdx)]
        for (var s in sched[d]['value']) {
          itemToFind = sched[d]['value'][s]['sched']
          var idx = daySchedule['value'].findIndex(schedIdx)
          if (idx !== -1) {
            daySchedule['value'][idx]['group'] = sched[d]['value'][s]['group']
          }
          if (idx == -1) {daySchedule['value'].push(sched[d]['value'][s])}
        }
      }
    }  else {
    // at this point sched contains all schedule for the teacher and schedule the editing one
    // so we merge schedule INTO sched
    //console.log("Teacher schedule merge, MERGING ..:", sched)
      for (var d in schedule) {
        itemToFind = schedule[d]['day']
        daySchedule = sched[sched.findIndex(dayIdx)]
        for (var s in schedule[d]['value']) {
          itemToFind = schedule[d]['value'][s]['sched']
          daySchedule['value'][daySchedule['value'].findIndex(schedIdx)]['value'] = schedule[d]['value'][s]['value']
        }
      }
      arr = sched
    } // end of merge when no group schedule
            function dayIdx (el) {
              return el.day == itemToFind
            }
            function schedIdx (el) {
              return el['sched'] == itemToFind
            }
    this.caseSchedule['items'] = arr
    //console.log("Teacher schedule merge, EXIT ..:", this.caseSchedule['items'])
  }

  validateTeacher() {

  }

  public selectedTeacher(teacher) {
    //console.log("Selected Teacher ...:", teacher)
    this.teacherForm.get('teacher').setValue(teacher['key']);
    this.termTeacher.next('');
  }

  // Push a search term into the observable stream.
  public  search(term: string): void {
    this.termTeacher.next(term);
  }

  scheduleIsChanged(par) {
    this.caseSchedule = par
    //console.log("Schedule is changed...:", this.caseSchedule['items'])
    this.modelDataUpdate ('schedule', this.caseSchedule['items'])
  }

  private modelDataUpdate(field, value) {
    if (field == 'startDate' || field == 'endDate') {
      value = new Date(value.getFullYear(),value.getMonth() , value.getDate()).valueOf()
    }
    //console.log("Model Data update ...: ", field, value)
    this.modelData[field] = value
    this.sendDataToParent(this.modelData)
  }

  sendDataToParent(data) {
    //console.log("CASE-TEACHER --> send to case-master...:", data)
    this.childClick.emit(data)
  }

}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/case-teacher/case-teacher.component.ts